import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, Type, ViewChild, OnChanges } from '@angular/core';
import { MapItemComponent, MapItem } from '@ui/shared/util-map';
import { PopupContentDirective } from '../../directives/popup-content.directive';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-map-sidebar-list-item',
    templateUrl: './map-sidebar-list-item.component.html',
    styleUrls: ['./map-sidebar-list-item.component.scss'],
    standalone: false,
})
export class MapSidebarListItemComponent<MapItemType extends MapItem> implements OnChanges {
    @Input({ required: true })
    public mapItem!: MapItemType;

    @Input()
    public customContentComponentType?: Type<MapItemComponent<MapItemType>> | undefined;

    @ViewChild(PopupContentDirective, { static: true })
    public uiPopupContentHost?: PopupContentDirective;

    @Output()
    public readonly mapItemClicked = new EventEmitter<MapItemType>();

    public onMapItemClicked(): void {
        this.mapItemClicked.emit(this.mapItem);
    }

    public loadPopupContent(): void {
        if (!this.uiPopupContentHost || !this.customContentComponentType) {
            return;
        }

        const viewContainerRef = this.uiPopupContentHost.viewContainerRef;

        viewContainerRef.clear();

        const componentRef = viewContainerRef.createComponent(this.customContentComponentType);

        componentRef.setInput('mapItem', this.mapItem);
    }

    public ngOnChanges(): void {
        this.loadPopupContent();
    }
}
